import ParaVoce2 from '@assets/Carousel Images/Produtos/pagar arrecadacao.svg';
import ParaVoce6 from '@assets/Carousel Images/Produtos/pagar assistente.svg';
import ParaVoce3 from '@assets/Carousel Images/Produtos/pagar compras online.svg';
import ParaVoce4 from '@assets/Carousel Images/Produtos/pagar condominio.svg';
import ParaVoce1 from '@assets/Carousel Images/Produtos/pagar educacao.svg';
import ParaVoce5 from '@assets/Carousel Images/Produtos/pagar tributos.svg';
import ParaEmpresa2 from '@assets/Carousel Images/Produtos/produtos pagar gerenciador alt.svg';
import ParaGoverno2 from '@assets/Carousel Images/Produtos/produtos pagar gerenciador alt.svg';
import ParaEmpresa1 from '@assets/Carousel Images/Produtos/produtos pagar gerenciador.svg';
import ParaGoverno1 from '@assets/Carousel Images/Produtos/produtos pagar gerenciador.svg';
import { X } from 'lucide-react';
import React, { useState, useEffect } from 'react';

import { useModal } from '@/presentation/providers/ModalProvider';

// Interfaces para tipagem
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

interface PolicyContentProps {
  policyId: string;
}

interface ProductsContentProps {
  segment: string;
}

interface Policy {
  title: string;
  content: string;
}

interface Product {
  id: number;
  image: string;
  title: string;
}

interface ProductsData {
  title: string;
  items: Product[];
}

// Componente Modal principal
export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  // Previne que o clique dentro do modal feche o modal
  const handleContentClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    e.stopPropagation();
  };

  return (
    <div
      className='fixed inset-0 flex items-center justify-center z-50 bg-primary-100 bg-opacity-70'
      onClick={onClose}
    >
      <div
        className='bg-primary-100 rounded-lg shadow-xl w-4/5 h-4/5 flex flex-col relative overflow-hidden'
        onClick={handleContentClick}
      >
        <button
          onClick={onClose}
          className='absolute top-4 right-4 p-2 text-gray-500 hover:text-gray-700 z-10'
          aria-label='Fechar'
        >
          <X size={24} color='white' />
        </button>

        <div className='flex-grow overflow-auto'>{children}</div>
      </div>
    </div>
  );
};

// Componente para mostrar políticas
export const PolicyContent: React.FC<PolicyContentProps> = ({ policyId }) => {
  const [policy, setPolicy] = useState<Policy | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const policies: Record<string, Policy> = {
      terms: {
        title: 'Termos de Uso',
        content: `POR FAVOR, LEIA COM ATENÇÃO ESTES TERMOS ANTES DE ACESSAR OU USAR A PLATAFORMA.

O presente instrumento estabelece as normas que regem a relação contratual, doravante denominada simplesmente "Termos e Condições de Uso", "TERMO" ou ainda "TCU", celebrada entre PAGAR LTDA., pessoa jurídica de direito privado, inscrita no CNPJ/MF sob o nº 35.636.239/0001-37, situada à Av. Raja Gabaglia, 4343, 3º andar, Bairro Santa Lucia, Belo Horizonte/MG, CEP nº 30.350-577 e o usuário cadastrado que atenda aos requisitos estabelecidos abaixo e que se torne usuário dos serviços oferecidos pela PAGAR, doravante denominado "USUÁRIO", devendo este TERMO ser observado integralmente pelas partes.

CLÁUSULA I - ACEITAÇÃO DO USUÁRIO

Ao efetuar o cadastro para uso da plataforma digital o USUÁRIO concorda de forma irretratável com os presentes termos e condições, que estabelecem o relacionamento contratual entre este e a PAGAR. A aceitação é imprescindível ao acessar e uso da plataforma digital.

Parágrafo Primeiro: Mediante referido acesso e uso, este TERMO imediatamente encerra, substitui e supera todos os acordos, Termos e acertos que eventualmente possa ter havido entre o USUÁRIO e a PAGAR no passado.

Parágrafo Segundo: O USUÁRIO SE responsabiliza cível e criminalmente pela veracidade de todas as informações prestadas para utilização dos serviços prestados pela PAGAR.

Parágrafo Terceiro: O USUÁRIO declara ter pleno conhecimento deste TCU, ao qual anui integralmente (sem ressalvas) e declara que, a partir de seu aceite, o presente TERMO e a Política de Privacidade da PAGAR terão força vinculante imediata entre as Partes, bem como as normas legais e regulamentares vigentes na República Federativa do Brasil e quaisquer outras regras e disposições que venham a integrar o presente instrumento.

Parágrafo Quarto: O USUÁRIO desde já concorda e reconhece que o presente TERMO, bem como a Política de Privacidade poderão, sem aviso prévio, sofrer alterações ou ter Termos adicionais que se aplicarão imediatamente à plataforma e que esses Termos adicionais serão divulgados em relação à respectiva prestação de serviço. Termos adicionais são complementares e considerados parte integrante destes Termos para os efeitos da respectiva plataforma digital. Termos adicionais prevalecerão sobre estes Termos em caso de conflito.

Parágrafo Quinto: Para que as alterações ou termos adicionais entrem em vigor e produzam efeitos legais imediatos basta à PAGAR comunicar formalmente sua existência ao USUÁRIO, seja e-mail ou por publicação evidente na própria plataforma digital, ou seja, aditamentos entrarão em vigor quando a PAGAR fizer a postagem da versão atualizada do TERMO ou das condições atualizadas ou Termos adicionais sobre o respectivo Serviço. O fato de o USUÁRIO continuar a acessar ou usar a plataforma de intermediação após essa postagem implica seu consentimento em vincular-se aos Termos alterados.

Parágrafo Sexto: A obtenção e uso de informações pessoais associadas à plataforma digital está disciplinada na Política de Privacidade da PAGAR, a qual faz parte integrante do presente instrumento, independente de transcrição e à qual o USUÁRIO declara ter conhecimento e consentimento.

CLÁUSULA II – OBJETO DA PAGAR

A PAGAR é uma plataforma financeira que, conforme cadastrado pelo USUÁRIO, recebe e realiza pagamentos de contas e boletos, conforme procedimento estabelecido na plataforma digital, tais como pagamentos automáticos, alertas de vencimento, compartilhamento de contas etc.

Parágrafo Primeiro: Os pagamentos deverão ser realizados por meio de cartão de crédito, de débito, pela carteira digital ou por acesso direto à conta bancária – corrente ou poupança – do USUÁRIO.

Parágrafo Segundo: A PAGAR não se responsabiliza pela rejeição de pagamento, cancelamento ou bloqueio de transações financeiras decorrente de ausência de limite de crédito ou saldo, bem como de problemas no relacionamento contratual entre o USUÁRIO e a administradora de seu cartão, ou ainda por falhas na prestação de serviços das operadoras de cartões e das instituições bancárias.

Parágrafo Terceiro: Considerando que a PAGAR não é instituição financeira ou seguradora, o USUÁRIO reconhece e aceita que, em razão da natureza da prestação de serviços, a responsabilidade da PAGAR se limita a fornecer uma plataforma de gestão financeira única para que o USUÁRIO organize o recebimento e o pagamento de contas e boletos, sendo o USUÁRIO o único responsável pela possibilidade de uso de seus cartões de crédito ou débito, das contas bancárias ou carteiras digitais.

Parágrafo Quarto: O USUÁRIO poderá cadastrar contas e boletos emitidos em seu nome e em nome de terceiros. Contudo, será inteiramente responsável pela autorização expressa desses terceiros. Para tanto, a PAGAR se resguarda o direito de, ao seu exclusivo critério, requerer documentos ou impor procedimentos destinados à verificação da anuência e segurança desses terceiros.

Parágrafo Quinto: Todas as operações financeiras executadas pelo USUÁRIO estarão condicionadas à aprovação da operadora de cartão de crédito ou débito ou carteira digital ou instituição de pagamento ou instituição financeira, bem como à compensação bancária, sobre as quais a PAGAR não tem ingerência e, por consectário lógico, não possui qualquer responsabilidade.

Parágrafo Sexto: Com exceção das operações na PIX (plataforma de pagamento instantâneo do Banco Central), que poderão ocorrer a qualquer dia e horário, as demais operações de pagamento de contas e boletos executadas pelo USUÁRIO em finais de semana e dias não úteis serão consideradas apenas no primeiro dia útil imediatamente subsequente. Em todos os casos, as informações e comprovantes de pagamentos, considerados prova suficiente do cumprimento das operações, serão disponibilizados ao USUÁRIO para sua segurança quanto à operação.

Parágrafo Sétimo: A PAGAR está autorizada a manter o registro de todas as operações efetuadas pelo USUÁRIO por meio da plataforma, podendo utilizar-se desses registros para fins probatórios perante os órgãos da administração pública caso necessário.

Parágrafo Oitavo: Considerando que as operações de pagamento de contas e boletos envolvem a utilização de serviços financeiros prestados por terceiros, independentes da PAGAR, fica esta [PAGAR] eximida de responsabilidades por quaisquer prejuízos decorrentes de falhas na prestação de serviços das instituições financeiras seja a que título for, inclusive das ocorrências de instabilidade de internet ou da rede mundial de computadores.

Parágrafo Nono: A PAGAR poderá se recusar – ainda que diante de mera suspeita – ao processamento de pagamentos de títulos com dados irregulares, fraudulentos, incompletos, inconsistentes ou que importem invalidade jurídica dos mesmos, tais como os casos de chargebacks ou em desacordo com este TERMO.

Parágrafo Décimo: A PAGAR poderá ser disponibilizada e acessada em conexão com Serviços e conteúdo de terceiros, tais como publicidade, a qual não controlará. O USUÁRIO reconhece que termos de uso e políticas de privacidade diferentes poderão ser aplicáveis ao uso desses serviços e conteúdo de terceiros, bem como que a PAGAR não endossa serviços e conteúdo de terceiros e a PAGAR não será, em hipótese alguma, responsável por nenhum produto ou serviço desses terceiros.

CLÁUSULA III – TITULARIDADE E DIREITOS AUTORAIS.

A plataforma financeira digital e todos os direitos sobre ela, ou seja, as ferramentas de pagamentos e seus códigos, o desenvolvimento, os programas de computador, equipamentos, domínios, marcas, logotipos, desenhos, estrutura, conteúdos, informação etc. são e permanecerão de propriedade da PAGAR. Este TERMO e o uso da plataforma não outorga ao USUÁRIO nem lhe confere qualquer direito sobre a forma de execução da prestação do serviço ou de usar ou, de qualquer modo, fazer referência à plataforma, códigos, nomes societários, logotipos da PAGAR, etc.

Parágrafo único: O USUÁRIO não poderá remover qualquer aviso de direito autoral, direito de marca ou outro aviso de direito de propriedade de qualquer parte da plataforma; reproduzir, modificar, preparar obras derivadas, distribuir, licenciar, locar, vender, revender, transferir, exibir, veicular, transmitir ou, de qualquer outro modo, explorar a plataforma, exceto da forma expressamente permitida pela PAGAR; decompilar, realizar engenharia reversa ou desmontar a plataforma; conectar, espelhar ou recortar qualquer parte da plataforma; fazer ou lançar quaisquer programas ou scripts com a finalidade de fazer scraping, indexação, pesquisa ou qualquer outra forma de obtenção de dados de qualquer parte da plataforma, ou de sobrecarregar ou prejudicar indevidamente a operação e/ou funcionalidade de qualquer aspecto da plataforma; ou tentar obter acesso não autorizado à plataforma ou prejudicar qualquer aspecto da mesma.

CLÁUSULA IV – CADASTRO E CONTA

Para utilizar a plataforma digital da PAGAR, o USUÁRIO deve registrar-se e manter uma única conta pessoal de usuário ("Conta") por meio de login e senha de acesso de livre escolha do USUÁRIO, atendendo aos critérios estabelecidos no aplicativo (aba Cadastro), dos quais importa salientar os seguintes:

1) Ser plenamente capaz, nos termos da Lei nº 10.406/2002, ou seja, ter pelo menos 18 anos, ser legalmente emancipado ou ter a maioridade exigida por lei em seu foro de domicílio para firmar contratos, apresentando seu nome completo, CPF válido, telefone e endereço eletrônico (e-mail), através dos quais serão validadas as informações prestadas e certifica-se da autenticidade da identidade do USUÁRIO, havendo ainda registro por foto do USUÁRIO e do seu documento de identificação.

2)A conta de titularidade do USUÁRIO é pessoal e intransferível e a senha de acesso é de livre escolha do USUÁRIO. Contudo, ela deve atender aos critérios de segurança indicados pela PAGAR a fim de evitar o acesso por terceiros. Tais dados (login e senha) jamais serão requeridos pela PAGAR ao USUÁRIO seja a que título for.

Parágrafo Primeiro: Nos termos da Política de Privacidade, a PAGAR poderá, ao seu exclusivo critério, ainda que por meio de terceiros, apurar a veracidade dos dados informados pelo USUÁRIO e a titularidade do e-mail e meios de pagamento, podendo ainda requerer ao USUÁRIO documentos que entenda pertinentes à verificação, bem como recorrer a bases de dados públicas ou privadas, inclusive podendo obter relatório de crédito pessoal.

Parágrafo Segundo: Apurando a PAGAR qualquer incorreção ou dados inverídicos no cadastro do USUÁRIO, esta poderá, ao seu exclusivo critério, notificar o USUÁRIO para retificação ou cancelar unilateralmente a conta do mesmo.

Parágrafo Terceiro: Deverá o USUÁRIO manter seus dados bancários, de seus cartões de crédito ou débito e de sua carteira digital devidamente atualizados, sob pena de impossibilitar a prestação de serviços pela PAGAR.

Parágrafo Quarto: A qualquer tempo e observando a Política de Privacidade do PAGAR, o USUÁRIO poderá encerrar sua conta através do próprio aplicativo, pelo que imediatamente perderá total acesso à plataforma PAGAR.

CLÁUSULA V – USO DA CONTA

O USUÁRIO utilizará a Plataforma da PAGAR exclusivamente para os fins estabelecidos na Cláusula II deste TERMO, estando ciente de que a PAGAR, em hipótese alguma, armazena códigos de segurança de cartões nem os solicitará ao usuário por qualquer meio.

CLÁUSULA VI – DO PRESTADOR DA SOLUÇÃO TECNOLÓGICA DE BANCO COMO SERVIÇO ("BANKING AS A SERVICE"/"BAAS")

O USUÁRIO/CLIENTE está ciente e concorda que a conta de pagamento de sua titularidade será aberta diretamente na CELCOIN INSTITUIÇÃO DE PAGAMENTO S.A, inscrita no CNPJ nº 13.935.893/0001-09, empresa parceira contratada pela PAGAR, para prestação da solução tecnológica de Banco como Serviço ("Bank as a Service"/"BaaS"), que contempla os procedimentos de abertura e gerenciamento de contas de pagamento, emissão de moeda eletrônica e serviços de processamento e liquidação.

O USUÁRIO/CLIENTE está ciente e concorda que todos os dados fornecidos para abertura e manutenção da conta, serão utilizados pela CELCOIN apenas para o cumprimento da relação contratual firmada com PAGAR, dos deveres advindos da regulamentação vigente, sempre em observância a legislação que versa sobre proteção de dados e segurança da informação. A CELCOIN poderá, a qualquer momento, solicitar informações complementares para fins legais e regulatórios.

CLAUSULA VII - OBRIGAÇÕES DO USUÁRIO

Além das demais obrigações deste TCU, o USUÁRIO deve:

1) Garantir que todas as informações cadastrais (pessoais, bancárias e dos títulos) estejam corretas, completas, verídicas e sempre atualizadas;
Obs: A PAGAR se reserva o direito de cancelar a conta do USURÁIO caso sejam verificadas ou mesmo se houver a mera suspeita de fraude, incorreções, informações incompletas, inverídicas ou desatualizadas, bem como se forem detectadas atividades abusivas, fraudulentas ou em violação do TERMO.
O USUÁRIO é o único responsável pelas informações fornecidas à PAGAR, bem como quaisquer ações tomadas por si ou por terceiros com o uso do login e senha de sua conta.

2) Manter o sigilo dos dados de sua conta e não franquear acesso a terceiros;

3) Notificar imediatamente à PAGAR em caso de suspeita de violação da Conta;

4) Observar os limites financeiros, seja de saldo da conta bancária do USUÁRIO seja de crédito de seu cartão junto à operadora, bem como os vencimentos das contas e boletos cadastrados no aplicativo PAGAR;

5) Observar irrestritamente a legislação da República Federativa do Brasil ou quaisquer outros regulamentos aplicáveis;

Parágrafo Primeiro: Em caso de descumprimento das regras entabuladas no TERMO ou de irregularidade nas informações e/ou transações, a PAGAR poderá recusar a operacionalização de pagamentos, bem como desabilitar ou encerrar definitivamente a conta do USUÁRIO, sem prejuízo das eventuais sanções cíveis e criminais que forem aplicáveis. Em suma, a PAGAR pode recusar pagamento, suspender ou encerrar sua conta, mas não limitada, nas seguintes situações:

1) Em caso de risco para a segurança ou privacidade da conta do USUÁRIO ou de outros usuários;
2) Em caso de ameaça para a segurança ou integridade da plataforma PAGAR;
3) Para proteger os direitos, propriedade ou segurança da PAGAR;
4) Em caso de suspeita ou confirmação de fraudes ou informação inverídicas, incompletas etc.;
5) Em caso de violação do TERMO;
6) Em caso de obrigação legal ou ordem judicial.

CLÁUSULA VIII - CONDIÇÕES FINAIS

Todas as atividades de coleta, tratamento, armazenamento e compartilhamento de informações do USUÁRIO serão regidos pela Política de Privacidade da PAGAR que faz parte deste TERMO independente de transcrição e à qual o USUÁRIO anui sem ressalvas.Ressalvadas as hipóteses vinculadas neste TERMO e de eventual requisição judicial, a PAGAR não compartilhará com terceiros os registros das transações do USUÁRIO.

Parágrafo Primeiro: A PAGAR notificará o USUÁRIO unicamente por carta registrada enviada ao endereço cadastrado, e-mail, SMS ou Whatsapp enviada para o número de celular cadastrado, sendo estas notificações consideradas válidas de pleno direito. Em hipótese alguma essas notificações ou qualquer outra comunicação conterá pedido de informações de acesso à conta do USUÁRIO ou códigos pessoais de segurança bancária e de cartões.

Parágrafo Segundo: Aviso Legal
OS SERVIÇOS SÃO PRESTADOS PELA PAGAR "COMO DISPONÍVEIS" SÃO FORNECIDOS SEM QUALQUER GARANTIA DE QUALQUER TIPO, SEJA EXPRESSA OU IMPLICITAMENTE, NÃO SE PODENDO SEQUER FALAR EM GARANTIA TÁCITA, MESMO CONSIDERANDO QUE A PAGAR FAZ TODO O POSSÍVEL PARA QUE O USUÁRIO TENHA A MELHOR EXPERIÊNCIA DISPONÍVEL.

DESTE MODO, A PAGAR, OS USUÁRIOS, OS TERCEIROS E OS EMISSORES DAS CONTAS E BOLETOS, BEM COMO AS INSTITUIÇÕES BANCÁRIAS E OPERADORAS DE CARTÃO DE CRÉDITOS E QUALQUER OUTRA PARTE QUE VENHA A TER RELAÇÃO COM A PLATAFORMA PAGAR REJEITAM EXPRESSAMENTE TODAS E QUAISQUER REPRESENTAÇÕES, GARANTIAS OU COMPROMISSOS DE QUE A PLATAFORMA SEJA PRECISA, COMPLETA, CONFIÁVEL, SEM ERROS, SEGURA E LIVRE DE VÍRUS OU DE ARQUIVOS MALICIOSOS QUE POSSAM IMPORTAR RISCOS, BEM COMO REJEITAM QUALQUER GARANTIA – INCLUSIVE AS LEGAIS - QUE SE POSSA VISLUMBRAR PELA UTILIZAÇÃO DA PLATAFORMA.

Em que pese a PAGAR envidar todos os esforços possíveis para oferecer o serviço com qualidade e segurança, esta NÃO GARANTE A PLENA QUALIDADE, ADEQUAÇÃO E A INVIOLABILIDADE DA SEGURANÇA, DE MODO QUE O USUÁRIO QUE TODO O RISCO DECORRENTE DO USO DA PLATAFORMA SERÁ SEMPRE SEU NA MÁXIMA MEDIDA PERMITIDA PELA LEI APLICÁVEL.

Parágrafo Terceiro: Limitação de Responsabilidade
A PAGAR NÃO SERÁ RESPONSÁVEL POR DANOS DIRETOS, INDIRETOS, INCIDENTAIS, ESPECIAIS, PUNITIVOS OU EMERGENTES, INCLUSIVE LUCROS CESSANTES, PERDA DE DADOS, DANOS MORAIS OU PATRIMONIAIS RELACIONADOS, ASSOCIADOS OU DECORRENTES DE QUALQUER USO DA PLATAFORMA AINDA QUE A PAGAR TENHA SIDO ALERTADA PARA A POSSIBILIDADE DESSES DANOS. A PAGAR NÃO SERÁ RESPONSÁVEL POR NENHUM DANO, OBRIGAÇÃO OU PREJUÍZO DECORRENTE DO: (i) SEU USO DA PLATAFORMA OU DA INCAPACIDADE DO USUÁRIO DE ACESSAR OU USAR A MESMA; OU (ii) QUALQUER OPERAÇÃO OU RELACIONAMENTO ENTRE VOCÊ E QUALQUER ENTIDADE BANCÁRIA OU OPERADORA DE CARTÕES, AINDA QUE A PAGAR TENHA SIDO ALERTADA PARA A POSSIBILIDADE DESSES DANOS. A PAGAR NÃO SERÁ RESPONSÁVEL POR ATRASOS OU FALHAS DECORRENTES DE CAUSAS FORA DO SEUS CONTROLE RAZOÁVEL E, TAMPOUCO, PELOS SERVIÇOS E SISTEMAS DISPONIBILIZADOS POR EMISSORES, ENTIDADES BANCÁRIAS E OPERADORES DE CARTÕES.

Parágrafo Quarto: Indenizações
O USUÁRIO concorda em indenizar e manter a PAGAR, seus sócios, diretores(as), conselheiros(as), empregados(as) e agentes isentos(as) de responsabilidade por todas e quaisquer reclamações, cobranças, prejuízos, responsabilidades e despesas (inclusive honorários advocatícios) decorrentes ou relacionados: (i) ao uso Da plataforma PAGAR, de serviços obtidos por meio do uso da mesma; (ii) descumprimento ou violação de qualquer disposição deste Termo; (iii) o uso, pela PAGAR, do Conteúdo de Usuário(a); ou (iv) violação dos direitos de terceiros.

Parágrafo Quinto: Licença limitada
Sujeito ao cumprimento destes Termos, a PAGAR outorga a você uma licença limitada, não exclusiva, não passível de sublicença, revogável e não transferível para acesso e uso de plataforma digital em seu dispositivo pessoal, exclusivamente para contratação de serviços prestados pela PAGAR, nos moldes da Cláusula II, observando-se ainda os termos da Cláusula III quando a propriedade intelectual da plataforma.

Parágrafo Sexto: Nulidade e Tolerância
Caso qualquer disposição deste instrumento seja tida como ilegal, inválida ou inexequível total ou parcialmente, por qualquer legislação, essa disposição ou parte dela será, naquela medida, considerada como não existente para os efeitos deste TCU, mas a legalidade, validade e exequibilidade das demais disposições contidas nestes Termos não serão afetadas. Nesse caso, a PAGAR substituirá a disposição ilegal, inválida ou inexequível, ou parte dela, por outra que seja legal, válida e exequível. Estes Termos constituem a totalidade do acordo e entendimento das partes sobre este assunto e substituem e prevalecem sobre todos os entendimentos e compromissos anteriores sobre este assunto. Nestes Termos, as palavras "inclusive" e "inclui" significam "incluindo, sem limitação". Do mesmo modo, a eventual tolerância de quaisquer das partes às atitudes contrárias a estes Termos e Condições de Uso, deve ser tomada sempre como mera liberalidade, não importando qualquer tipo de novação contratual.

CLÁUSULA IX - JURISDIÇÃO E LEI APLICÁVEL

Este TERMO é regido e interpretado exclusivamente de acordo com as leis da Republica Federativa do Brasil. Qualquer reclamação, conflito ou controvérsia que surgir deste contrato ou a ele relacionada, inclusive que diga respeito a sua validade, interpretação ou exequibilidade, será solucionada exclusivamente pelos tribunais do foro da comarca onde a PAGAR está sediada, com exclusão de qualquer outro por mais privilegiado que seja.`,
      },
      'terms-adhesion': {
        title: 'Termo de Adesão ao DDA',
        content: `Termo de adesão ao DDA - Débito Direto Autorizado

RESUMO

O Débito Direto Autorizado — DDA é um serviço bancário que disponibiliza de uma forma simples todos os boletos emitidos contra o CPF ou o CNPJ do usuário. São exemplos de boletos bancários, mas não se limitando a isso, nem de forma exaustiva ou mandatória: cartões de crédito, aluguéis, condomínios, planos de saúde, mensalidades escolares, financiamentos, entre outros.

Importante informar que a adesão ao DDA não implica em débito automático destes boletos. Qualquer ato de pagamento somente ocorrerá mediante o consentimento e a autorização do usuário.

Ao aceitar este termo de adesão, o usuário concorda em compartilhar os seus boletos bancários com o aplicativo PAGAR para melhor gestão, controle e pagamento dos seus compromissos financeiros.

OBJETO

O presente Termo de Adesão ao DDA Débito Direto Autorizado, refere-se à adesão do usuário ao sistema de Débito Direto Autorizado (DDA) através da plataforma PAGAR LTDA., para consulta e pagamento de boletos registrados via CIP (Câmara Interbancária de Pagamentos).

Ao concordar com este termo, o usuário adere ao sistema de Débito Direto Autorizado — DDA e declara, em caráter irrevogável e irretratável, ter ciência e concordar que:

Após o cadastramento no Débito Direto Autorizado — DDA, o usuário poderá́ não mais receber em papel os boletos de cobrança registradas contra ele, responsabilizando-se por consultar, de forma eletrônica, todas as informações de cobrança existentes em seu nome nas contas de pagamento e/ou de depósito elegíveis à participação no Débito Direto Autorizado — DDA.

O usuário ficará responsável por diariamente consultar, agendar, pagar, ou complementar os dados dos boletos de cobrança exibidos no DDA, uma vez que o DDA não realiza pagamentos ou agendamentos de forma automática. É necessário ainda que se tenha saldo em conta para efetuar os pagamentos em questão.

Fica sob responsabilidade do usuário o pagamento dos boletos de cobrança exibidos no DDA. A falta de pagamento dos boletos de cobrança exibidos via DDA produz efeitos de mora, não havendo responsabilidade do PAGAR se os boletos não forem pagos por atos ou omissões do usuário ou dos emitentes.

Fica sob responsabilidade do usuário o pagamento da dívida representada pelas cobranças exibidas no DDA. O usuário está ciente de que a disponibilização dos boletos por meio do DDA resultará na ciência do seu recebimento e que o não recebimento dos boletos em papel, não isentará a relação com o emissor do boleto.

Através da aceitação deste termo, o usuário autoriza o PAGAR a consultar no sistema DDA, gerido pela CIP — Câmara Interbancária de Pagamentos, as cobranças bancárias em seu nome, e apresentá-las através do aplicativo PAGAR.

Caso não seja possível acessar os boletos pelo aplicativo PAGAR, fica a cargo do usuário verificar com PAGAR, através do e-mail: contato@pagar.com.br, para obter as informações sobre suas cobranças bancárias e poder efetuar o pagamento até a data de vencimento.

CONDIÇÕES DO SERVIÇO DO DDA

É responsabilidade do usuário consultar e pagar pontualmente os boletos de cobranças apresentados por meio do DDA, e ficará responsável pela mora e inadimplemento junto aos cedentes, caso não cumpra com as obrigações de pagamentos.

As cobranças bancárias poderão ser pagas até a data de vencimento do título. Após vencimento, poderão ser aplicados eventuais encargos moratórios, previstos no boleto em questão.

O PAGAR disponibiliza os boletos que realmente foram emitidos e registrados contra o usuário, garantindo assim a sua autenticidade. No entanto, cabe ao usuário verificar a legitimidade das cobranças a fim de evitar cobrança indevida ou fraudulenta por parte do emissor.

O PAGAR não se responsabiliza pela exatidão dos dados apresentados e disponibilizados pelos emissores, ficando a cargo do usuário verificar as informações ou correções necessárias junto ao próprio cedente.

O PAGAR não se responsabiliza por atos, omissões, faltas ou incorreções nos dados lançados nos boletos de cobrança, que impossibilitem a apresentação dessas cobranças através do DDA e consequentemente através da plataforma PAGAR.

O PAGAR poderá definir os dados a serem apresentados e forma de apresentação dos boletos capturados por meio do DDA, dentro da sua plataforma.

O usuário se compromete a manter seus dados cadastrais atualizados e compromete-se a notificar qualquer alteração ou atualização cadastral, sob pena de responder por eventuais perdas e danos.

Recomenda-se que o pagamento das cobranças apresentadas através do DDA, sejam realizadas por meio do aplicativo PAGAR, para evitar duplicidade de pagamentos (em casos onde o boleto seja apresentado via DDA e também seja postado em papel pelo cedente).

As cobranças bancárias apresentadas por meio do DDA, não apresentarão a linha digitável e o código de barras comumente encontrados nos boletos de cobrança. Assim fica a critério do usuário a consulta e seleção dos boletos que deseja pagar.

O PAGAR poderá apresentar os boletos de cobrança após sua data de vencimento. Porém, no caso de boletos em atraso (sem pagamento), faz-se necessário que o usuário entre em contato com o cedente para solicitar a atualização do boleto em questão, incluindo encargos moratórios quando houver.

O PAGAR não se responsabilizará por negligência do usuário ou descumprimento das obrigações previstas neste termo de adesão.

ADESÃO E EXCLUSÃO

O presente Termo de Adesão terá início a partir da data de sua adesão e aceitação pelo usuário, tendo sua vigência por prazo indeterminado.

As partes poderão rescindi-lo a qualquer tempo mediante solicitação dentro da plataforma do PAGAR, com até 5 (cinco) dias úteis de antecedência.

Com a exclusão do usuário no sistema do DDA, caso o emissor efetue eventuais alterações ou atualizações de dados dos boletos antes do vencimento, tais atualizações não serão mais apresentadas na plataforma do PAGAR.

Após a exclusão definitiva do usuário, serão retomados os envios dos boletos em papel, a partir da data de exclusão no sistema do DDA. Os boletos apresentados via DDA anteriores à data de exclusão, continuarão disponíveis somente de forma digital na plataforma.

O PAGAR não disponibilizará ao usuário os boletos de cobrança que já tiverem sido apresentados por meio do DDA até a data da exclusão e que ainda estejam pendentes de pagamento. O usuário fica responsável por solicitar ao emissor nova via para liquidação dos boletos em questão.

O usuário declara-se ciente de que o cancelamento deste serviço na plataforma PAGAR, não implica em exclusão do sistema DDA em outras instituições financeiras onde tenha aderido.

O eventual encerramento ou inativação, pelo usuário, do seu cadastro ou uso da plataforma PAGAR que disponibiliza o serviço DDA deve ser precedido de prévio cancelamento de sua adesão a este serviço.

DISPOSIÇÕES GERAIS

O PAGAR poderá, a qualquer tempo, promover alterações nas disposições deste instrumento, comunicando as alterações realizadas e disponibilizando nova versão deste instrumento para ciência do usuário.

SOLUÇÃO DE CONTROVÉRSIAS

Na ocorrência de eventuais conflitos, o usuário deve entrar em contato com o PAGAR através do canal contato@pagar.com.br. Ficando esse canal como o primeiro meio para resolução de controvérsias, a fim de evitar a judicialização de questões que podem ser resolvidas administrativamente e de forma amigável.

O PAGAR presa pela efetiva resolução das controvérsias e solução das reclamações apresentadas pelos usuários.

As leis vigentes na República Federativa do Brasil regem todos os itens deste termo de adesão. Para dirimir eventuais controvérsias decorrentes deste instrumento fica eleito o foro da comarca de Belo Horizonte, renunciando as partes a quaisquer outros.`,
      },
      privacy: {
        title: 'Política de Privacidade',
        content: `Política de privacidade

1. INTRODUÇÃO
A Política de Privacidade da PAGAR LTDA., contém informações sobre coleta, uso, armazenamento, privacidade, proteção, enfim o tratamento de dados pessoais do Usuário (você), com a finalidade de demonstrar transparência e respeito quanto ao assunto e esclarecer a todos interessados sobre os tipos de dados pessoais que são tratados, as finalidades, as hipóteses legais e a forma como o Usuário pode contatar a BilIApp para exercer seus direitos.

A política foi elaborada em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei 13.709/2018), o Marco Civil da Internet (Lei 12.965/2014).

Esta Política abrange o APP PAGAR e o www.pagar.com.br ("site"), denominados de plataforma PAGAR. Ao utilizar a plataforma, certifique-se que compreendeu todas as condições estabelecidas neste instrumento. Após ler, compreender e concordar com todo o conteúdo desta Política de Privacidade, você poderá aderir a ela. Caso não concorde, deverá suspender o uso da plataforma PAGAR. O Usuário somente poderá utilizar a plataforma e os demais produtos e serviços oferecidos pela PAGAR, clicando na caixa "Li e Aceito" que implicará na aceitação plena, irrestrita e sem reservas de todos os termos e condições previstos nesta Política de Privacidade.

A PAGAR lembra que, caso o Usuário clique em um banner publicitário ou de qualquer forma aceite ser direcionado ao site de anunciante, não estará mais sujeito à Política de Privacidade da PAGAR, isentando, neste ato, a PAGAR de qualquer responsabilidade.

2. DEFINIÇÕES
São apresentados os significados de um conjunto de termos importantes para facilitar os entendimentos desta Política de Privacidade.

PAGAR: Trata-se da empresa PAGAR LTDA., pessoa jurídica de direito privado, inscrita no CNPJ/MF sob o nº 35.636.239/0001-37, situada à Avenida Raja Gabaglia, 4343, 3º andar, Bairro Santa Lucia, Belo Horizonte/MG, CEP nº 30.350-577.

LGPD: É a Lei Geral de Proteção de Dados Pessoais (Lei Nº 13.709, de agosto de 2018).

ANPD: É a Autoridade Nacional de Proteção de Dados.

Controlador: Pessoa natural ou jurídica, de direito público ou privado, a quem competem as decisões referentes ao tratamento de dados pessoais.

Operador: Pessoa natural ou jurídica, que realiza operações de tratamento de dados pessoais em nome do controlador.

Titular: Pessoa natural a quem se referem os dados pessoais que são objeto de tratamento.

Dado Pessoal: Informação relacionada a pessoa natural (pessoa física) identificada ou identificável, tais como o nome, e-mail, telefone, CPF, RG, CNH etc.

Dado Pessoal Sensível: Dado Pessoal sobre origem racial ou étnica, convicção religiosa, opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, dado referente à saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma pessoa natural.

Encarregado: Pessoa indicada pelo controlador e operador para atuar como canal de comunicação entre a PAGAR, os titulares dos dados e a Autoridade Nacional de Proteção de Dados (ANPD). O Encarregado também é conhecido como DPO (Data Protection Officer).

Plataforma PAGAR: Trata-se do APP (PAGAR) e o site web (World Wide Web) www.pagar.com.br, de responsabilidade, propriedade e operação da PAGAR.

Cookies ou Dados de Navegação:
-Os cookies referem-se a arquivos de texto enviados pela plataforma ao computador do Usuário e que nele ficam armazenados, com informações relacionadas à navegação no site. Tais informações são relacionadas aos dados de acesso como local e horário de acesso e são armazenadas pelo navegador do Usuário para que o servidor da plataforma possa lê-las posteriormente a fim de personalizar os serviços da plataforma;O cookie persistente permanece no disco rígido do Usuário, depois que o navegador é fechado e será usado pelo navegador em visitas subsequentes às plataformas.

-O cookie persistente pode ser removido seguindo as instruções do seu navegador. Já o cookie de sessão é temporário e desaparece depois que o navegador é fechado. É possível redefinir seu navegador da web para recusar todos os cookies, porém alguns recursos da plataforma podem não funcionar corretamente se a capacidade de aceitar cookies estiver desabilitada.

Tratamento: Toda operação realizada com dados pessoais, como coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação, controle, modificação, comunicação, transferência, difusão ou extração.

Usuário: É a pessoa que utiliza a plataforma PAGAR, que pode ser tanto pessoa física como jurídica, podendo ser cliente ou não, que fornece dados pessoais para permitir contato, tratar de interesses afins e utilizar a plataforma.

3. CIÊNCIA DO TITULAR
Ao acessar a plataforma e usar os produtos e serviços disponibilizados pela PAGAR, o Usuário expressa ciência e autoriza a PAGAR realizar o tratamento de seus dados pessoais para as finalidades determinadas e previstas nesta Política de Privacidade.

O Usuário pode contatar com a PAGAR, por meio do canal de comunicação oficial informado nesta Política de Privacidade, para tratar de dúvidas, esclarecimentos e direitos do titular.

4. DADOS COLETADOS

4.1. Dados do Usuário
Ao utilizar a plataforma, a PAGAR poderá realizar o tratamento de dados pessoais do Usuário, em suas operações comerciais e empresariais para prover os produtos e serviços.

4.2. Dados Pessoais
Para acessar e utilizar a plataforma PAGAR, o Usuário terá que fornecer seus dados pessoais para sua identificação e obter acesso aos conteúdos e serviços. Para tanto, a PAGAR poderá realizar o tratamento dos dados pessoais:

Nome completo
CPF
Data de Nascimento
Carteira de Identidade (imagem)
Número da Carteira de Identidade
Nacionalidade
Naturalidade
Placa do Veículo
Número do Renavam (veículo)
Código do Imóvel
Usuário e senha de acesso em concessionárias 
Instituição Financeira (Nome, Número do Banco, Agência e Conta)
Número do Cartão de Crédito
Bandeira emissora do Cartão de Crédito
Nome da instituição escolar do titular ou de dependente
Nome do clube social
Nome da empresa prestadora de plano de saúde e dental
Nome de empresas emissoras de boletos, faturas e contas (exemplo: escola, clube, IPVA, entre outros)
Número de identificação do registro em concessionária (fornecedora de luz, energia, água, provedora de serviços de internet e comunicações)
CBO - Classificação Brasileira de Ocupações (se aplicável)
Razão social da empresa (se aplicável)
E-mail
Telefone
WhatsApp
Endereço completo (Avenida/Rua, Cidade, Estado, Bairro, CEP)
Login (Usuário de identificação na plataforma)
Senha (para autenticação na plataforma)
Cookies
IP (Internet Protocol)

4.3. Dados Pessoais Sensíveis
A PAGAR faz tratamento de dados pessoais sensíveis dos Usuários, entre eles:
PEP (Pessoa Exposta Politicamente)
Biométricos (finger print, selfie)

4.4. Dados Pessoais de Crianças e Adolescentes
A PAGAR faz tratamento de dados pessoais de crianças e adolescentes em seu melhor interesse e quando obtido o termo de consentimento específico e em destaque dado por um dos pais ou pelo responsável legal, entre eles estão:
Nome completo
CPF
Telefone
E-mail
Nome da instituição escolar

5. REQUISITOS PARA TRATAMENTO DE DADOS PESSOAIS
A PAGAR, para o desenvolvimento de suas atividades comerciais e reguladoras, faz tratamento de dados pessoais observando a boa-fé, os dez princípios previstos e rigorosamente dentro das bases legais da Lei Geral de Proteção de Dados Pessoais.

5.1 Bases Legais para o Tratamento de Dados Pessoais
A PAGAR faz o tratamento dos dados pessoais para as seguintes bases legais:

Para o cumprimento de obrigação legal ou regulatória pelo controlador;

Para a proteção do crédito, inclusive quanto ao disposto na legislação pertinente;

Quando necessário para a execução de contrato ou de procedimentos preliminares relacionados a contrato do qual seja parte o titular, a pedido do titular dos dados.

Para a proteção do crédito;

Para o exercício regular de direitos em processo judicial, administrativo ou arbitral;

Quando necessário para atender aos interesses legítimos do controlador ou de terceiros, exceto no caso de prevalecer em direitos e liberdades fundamentais do titular que exijam a proteção dos dados pessoais.

6. FINALIDADES PARA TRATAMENTO DOS DADOS
A PAGAR faz tratamento de dados pessoais para as seguintes finalidades:

Para atender solicitações dos Usuários a respeito dos serviços oferecidos pela empresa;

Para emissão de notas fiscais de fornecimento, remessa, serviços e quaisquer outras obrigações legais de emissão de documentos;

Para aprimorar a funcionalidade da plataforma e aperfeiçoar os serviços ofertados;

Para formalização de contrato entre a PAGAR, fornecedores, prestadores de serviços, empresas parceiras e clientes;

Para tratamento dos dados nos centros de processamento de dados da PAGAR, ou sistema aplicativo que pode estar fora do território brasileiro, onde a PAGAR mantém os dados pessoais e demais dados salvaguardados. Os países que hospedam os dados possuem legislações de proteção de dados pessoais similares à LGPD;

Para compartilhar dados pessoais mínimos necessários com parceiros da PAGAR;

Para pesquisar a situação do titular, via empresa IDWALL, a situação na Receita Federal, na lista de sanções do Conselho de Segurança da ONU, na lista de sanções OFAC (Office of Foreing Assets Control) e em Birô privado para consulta de PEP (Pessoa Exposta Politicamente) relacionado;

Para emitir boleto de cobrança devido aquisição de serviços;

Para fazer atividades de cobranças quando aplicável;

Para compartilhar dados pessoais com autoridades públicas sempre que exigido por lei ou por determinação de autoridade pública, a PAGAR poderá divulgar ou compartilhar, no todo ou em parte, com ou sem aviso prévio, os dados pessoais do Usuário;

Para identificar se o usuário é detentor dos dados fornecidos;

Para permitir o Usuário ser um cliente da PAGAR;

Para ter acesso aos boletos cadastrados no CPF do cliente no DDA (Débito Direto Autorizado);

Para disponibilizar para o cliente a visão de suas contas a pagar;

Para disponibilizar para o cliente o seu saldo bancário para que ele tome a decisão por qual banco vai realizar o pagamento da conta;

Para que o cliente possa realizar as transações para pagamento de contas;

Para fazer o cadastramento de pessoa física e/ou jurídica (tratando dados de pessoa física) para uso do PAGAR;

Para compartilhar dados pessoais, para responder a processos judiciais ou para participar de eventuais litígios ou demandas judiciais ou administrativas de qualquer natureza.

7. ARMAZENAMENTO E TÉRMINO DO TRATAMENTO DE DADOS PESSOAIS

7.1. Local de Armazenamento
Os dados pessoais objetos de tratamento pela PAGAR podem ser armazenados em centros de armazenamento de dados físicos ou virtuais, em centros de processamentos de dados ou por meio de serviços disponibilizados por parceiros que podem estar localizados no Brasil e/ou em outros países, tais como Estados Unidos da América e países da União Europeia. Preferencialmente a PAGAR faz uso de computação em nuvem com os dados sendo tratados no Brasil.

7.2. Término do Tratamento de Dados
A PAGAR, após a verificação que a finalidade do dado pessoal foi alcançada ou que deixou de ser necessária, irá descartá-lo de forma segura ou anonimizá-lo.

7.3. Não Eliminação de Dados Pessoais
Desde que estejam presentes quaisquer dos fundamentos previstos abaixo, a PAGAR se reserva o direito de não eliminar os dados pessoais do Usuário, mesmo após o recebimento de solicitação nesse sentido:

Para cumprimento de obrigação legal ou contratual;
Exercício regular de direitos em processo judicial, administrativo ou arbitral.

7.4. Fusão ou Venda de Plataformas
Os dados dos Usuários poderão ser transferidos a terceiros em decorrência da venda, aquisição, fusão, reorganização societária ou qualquer outra mudança de controle da PAGAR. Nesse caso, a plataforma irá garantir a continuidade da proteção de seus dados pessoais e irá comunicar o Usuário, com antecedência, caso essa transferência implique qualquer alteração em sua Política de Privacidade.

8. SEGURANÇA DOS DADOS

8.1. Medidas de Proteção de Dados
A PAGAR utiliza medidas técnicas e administrativas e emprega seus melhores esforços para proteger os dados pessoais objetos de tratamento contra perda, roubo ou qualquer modalidade de uso ou acesso indevido e não autorizado, divulgação, alteração e destruição.

8.2. Ausência de Garantias
A despeito de todas as medidas de segurança adotadas pela PAGAR, não é possível garantir e a PAGAR não garante a não ocorrência de vazamentos, interceptações e violações de sistemas e bases de dados.

8.3. Tratamento de Incidentes de Segurança
Na hipótese de ocorrência de um incidente de segurança que resulte em destruição, perda, alteração, acesso não autorizado ou vazamento de dados pessoais, a PAGAR avaliará os riscos e eventuais danos causados e comunicará, em prazo razoável, o titular e as autoridades públicas competentes a esse respeito. A PAGAR adotará todas as medidas disponíveis e razoáveis para mitigar eventuais danos causados aos titulares de dados pessoais que tenham sido objeto de tratamento pela PAGAR.

9. SEGURANÇA DA INFORMAÇÃO
A PAGAR está comprometida a observar todas as normas aplicáveis em matéria de medidas de segurança. Além disso, emprega os padrões mais avançados da indústria em matéria de proteção das informações pessoais, incluindo, entre outras medidas, firewalls e Secure Socket Layers ("SSL"). A PAGAR considera os dados de seus Usuários como um bem precioso que deve ser protegido de qualquer perda ou acesso não autorizado. Emprega, portanto, diversas técnicas de segurança da informação para protegê-los de acessos não autorizados.

Além dos esforços técnicos, a PAGAR também adota medidas institucionais e administrativas visando a proteção de Dados Pessoais, à exemplo do seu programa de governança de privacidade e proteção de dados, campanhas de conscientização e realização de treinamentos periódicos.

O acesso às informações coletadas é restrito aos funcionários e pessoas autorizadas. Aqueles que se utilizarem indevidamente dessas informações, em violação das políticas internas adotadas, estarão sujeitos a sanções administrativas, disciplinares e legais cabíveis.

Embora a PAGAR adote os melhores esforços no sentido de preservar a sua privacidade e proteger os seus Dados Pessoais, nenhuma transmissão de informações é totalmente segura, de modo que a PAGAR pode garantir integralmente que todas as informações que recebe e/ou envia não sejam alvo de acessos não autorizados perpetrados por meio de métodos desenvolvidos para obter informações de forma indevida, como falhas técnicas, vírus ou invasões do banco de dados do website e APP. De qualquer forma, na remota hipótese de incidência de episódios desta natureza, a PAGAR garante os maiores esforços para remediar as consequências do evento e notificar de acordo com as legislações legais aplicáveis.

9.1 Senha Pessoal
Para acesso dos serviços reservado unicamente ao Usuário devidamente registrado, este irá dispor de uma senha pessoal. Esta senha, escolhida pelo próprio Usuário, deve ser mantida sob absoluta confidencialidade e, em nenhum caso, deverá ser revelada ou compartilhada com outras pessoas.

A PAGAR recomenda a troca constante da senha do Usuário.

Não obstante sejam mantidos os seus dados em confidencialidade, de acordo com os termos desta Política de Privacidade, será responsabilidade do Usuário manter o login e a senha de acesso nas plataformas de forma segura, não devendo fornecê-los a ninguém.

O Usuário será responsável por todos os atos que sejam realizados com o uso de seu login e senha pessoal, o que inclui responsabilização por prejuízos que possam vir a sofrer de outras pessoas, por qualquer motivo.

Caso desconfie que seu login e senha de acesso à plataformas PAGAR tenham sido roubados ou sejam de conhecimento de outras pessoas, por qualquer razão, o Usuário deverá imediatamente comunicar a PAGAR, através de canal de contato que consta no site da PAGAR (www.pagar.com.br), na aba Contato.

10. DIREITOS
A PAGAR assegura que as informações (textos, imagens, sons e/ou aplicativos) contidas na plataforma estão de acordo com a legislação e normativos que regulam os direitos autorais, marcas e patentes, não sendo permitidas modificações, cópias, reproduções ou quaisquer outras formas de utilização para fins comerciais sem o consentimento prévio e expresso da PAGAR.

A PAGAR não se responsabiliza por eventuais danos e/ou problemas decorrentes da demora, interrupção ou bloqueio nas transmissões de dados ocorridos na Internet.

11. DÚVIDAS OU QUESTÕES

11.1. Direito do Titular
A PAGAR receberá dúvidas e questões do Titular de dados pessoais, investigará e responderá, dentro de um prazo considerado razoável, qualquer solicitação ou reclamação sobre a forma de como trata os dados pessoais, incluindo reclamações sobre desrespeito aos direitos sob as leis de privacidade e proteção de dados pessoais vigentes, disponibilizando o canal de contato, oferecendo e não se limitando, para:

Fazer perguntas ou comentários sobre esta Política de Privacidade e práticas de privacidade e proteção de dados pessoais;
Fazer uma reclamação;
Confirmação da existência de tratamento dos dados pessoais;
Obter informações sobre como acessar os dados pessoais;
Realizar a correção de dados pessoais incompletos, inexatos ou desatualizados;
Obter informações sobre a anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto na legislação vigente;
Obter informações sobre a portabilidade dos seus dados pessoais a outro fornecedor de serviço ou produto, mediante requisição expressa, em conformidade com a legislação vigente;
Solicitar a eliminação dos dados pessoais tratados com o seu consentimento, excetuando-se as hipóteses previstas na legislação vigente;
Solicitar detalhes das entidades públicas e privadas com as quais realizamos o compartilhamento de seus dados pessoais;
Obter informações sobre a possibilidade de não fornecer consentimento e sobre as consequências dessa negativa;
Realizar a revogação do consentimento para o tratamento dos dados pessoais, excetuando-se as hipóteses previstas na legislação vigente;
Demais direitos do titular dos dados pessoais, conforme legislação vigente.

11.2. Atendimento de Solicitações do Titular
Antes de atender a qualquer solicitação do Titular de Dados Pessoais, a PAGAR poderá solicitar informações adicionais para confirmar a identidade do solicitante e para fins de segurança. Caso a solicitação seja infundada ou não tenha respaldo legal ou contratual, a PAGAR recusará o atendimento da solicitação e proverá os devidos motivos.

Na hipótese em que a PAGAR não seja o Controlador dos Dados Pessoais do solicitante, a PAGAR informará ao solicitante a respeito de sua posição como Operadora de Dados Pessoais e, se possível, indicará o Controlador responsável por atender à solicitação do Titular dos Dados Pessoais.

Todas as solicitações direcionadas para o canal de contato serão tratadas de forma gratuita.

12. ATUALIZAÇÃO DA POLÍTICA DE PRIVACIDADE
Com a finalidade de garantir a privacidade do Usuário, bem como a segurança de seus dados, a PAGAR se compromete a regularmente reavaliar a sua Política de Privacidade e adaptá-la, conforme necessário.

A PAGAR poderá atualizar esta Política periodicamente, cabendo ao Usuário verificar a versão mais atual no momento da utilização da plataforma. Caso o Usuário continue a utilizar o PAGAR, será considerado que o Usuário concorda com alterações elaboradas nesta atualização da Política de Privacidade.

Data da Versão Atual: 25/07/2022
Data da Versão Anterior: 02/11/2021

13. CANAL DE CONTATO
A PAGAR disponibiliza o seguinte canal de contato para o Titular para questões sobre esta Política de Privacidade, ou sobre o exercício dos direitos previstos neste instrumento ou na legislação vigente no que diz respeito à privacidade e proteção de dados pessoais.

Encarregado (DPO): Lenon Rodrigues Botelho Fernandes
E-mail: dados@pagar.com.br

14. JURISDIÇÃO PARA RESOLUÇÃO DE CONFLITOS
Toda e qualquer controvérsia oriunda dos termos expostos na presente Política de Privacidade serão solucionados de acordo com a lei brasileira, sendo competente o foro da cidade de Belo Horizonte - MG, Comarca da cidade, com exclusão de qualquer outro por mais privilegiado que seja.`,
      },
      cookies: {
        title: 'Política de Cookies',
        content: `Política de Cookies

O QUE SÃO E COMO A PAGAR UTILIZA COOKIES

Cookies são arquivos ou informações que podem ser armazenadas em seus dispositivos quando você visita os sites ou utiliza os serviços online. Geralmente, um cookie contém o nome do site que o originou, seu tempo de vida e um valor, que é gerado aleatoriamente. A PAGAR utiliza cookies para facilitar o uso e melhor adaptar o website e aplicações aos interesses e necessidades de seus Usuários, bem como para auxiliar e melhorar suas estruturas e seus conteúdos. Os cookies também podem ser utilizados para acelerar suas atividades e experiências futuras em nossos serviços.

Por meio de cookies, o Site armazena informações sobre as atividades do navegador, incluindo endereço IP (Protocolo Internet) e a página acessada. Esses registros de atividades (logs), que poderão compreender dados como o endereço IP, as ações efetuadas no Site, as páginas acessadas, as datas e horários de cada ação e de acesso a cada página do Site e as informações sobre o dispositivo utilizado, versão de sistema operacional, navegador, dentre outros aplicativos instalados, serão utilizados apenas para fins estatísticos e de métricas dos serviços disponibilizados, para a investigação de fraudes ou de alterações indevidas em seus sistemas e cadastros, não tendo como finalidade o fornecimento dos dados a terceiros sem autorização expressa do Usuário.

TIPO DE COOKIE E O QUE ELE FAZ

ESSENCIAIS

O que eles fazem: São fundamentais para o funcionamento correto do site e para o uso dos serviços oferecidos. Você pode configurar seu navegador para bloquear ou alertar sobre esses cookies, mas partes do site podem não funcionar corretamente.

TIPOS DE DADOS COLETADOS:

- Dados de navegação: Endereço IP, data e hora de acesso, localização geográfica, tipo de navegador, duração da visita e páginas visitadas.

- Dados sobre o dispositivo de acesso: Modelo, fabricante, sistema operacional, operadora de telefonia, tipo de navegador e tipo e velocidade da conexão.

GESTÃO DE COOKIES

É possível que você, Usuário de nossos serviços, a qualquer momento, utilize as configurações de seu navegador de preferência para desabilitar ou remover cookies. Contudo, alertamos que, ao bloquear certos tipos de cookies, algumas funcionalidades dos nossos serviços poderão não funcionar da maneira idealmente esperada, bem como aspectos de segurança das informações e prevenção a fraudes poderão ser impactados.

Para mais informações sobre como gerir os cookies diretamente em seu navegador de preferência, orientamos a consulta aos links abaixo:

Internet Explorer: https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies

Mozilla Firefox: https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam

Google/Chrome: https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=pt-BR

Safari: https://support.apple.com/pt-br/guide/safari/sfri11471/mac

CANAL DE CONTATO

A PAGAR disponibiliza o canal de contato para dirimir quaisquer dúvidas a respeito da Política de Cookies, através do e-mail: dados@pagar.com.br`,
      },
      conduct: {
        title: 'Código de Conduta',
        content: `1. OBJETIVO
Estabelecer o Código de Conduta que engloba as Políticas de Compliance, Anticorrupção, 
Prevenção à Lavagem de Dinheiro e ao Financiamento do Terrorismo e Segurança 
Cibernética, da Informação e Privacidade na empresa PAGAR LTDA.

2. INTRODUÇÃO
Caros colaboradores, clientes e fornecedores,
O PAGAR é uma plataforma financeira de open banking, que visa organizar e simplificar 
pagamentos para seus clientes, via App. 
Na atual dinâmica mundial, manchetes negativas envolvendo escândalos de suborno ou 
propina, violações à lei de concorrência, a violação de leis de proteção de dados ou lavagem 
de dinheiro podem arruinar a reputação de uma empresa. 
O comportamento ilegal, irregular, preconceituoso ou discriminatório também pode causar 
consequências legais graves para o indivíduo envolvido, para a administração e para a própria 
empresa.
Para proteger a reputação de nossa empresa, gestores, colaboradores, clientes, fornecedores 
e prestadores de serviços, a PAGAR investe na Governança Corporativa, no Compliance com 
Leis anti corrupção, lavagem de dinheiro, dentre outros.
Este Código de Conduta faz parte do Sistema de Gerenciamento de Compliance da PAGAR, 
que serve como apoio na garantia do cumprimento das leis e regulamentos em toda a 
empresa, projetado para cumprir os objetivos de proteger os colaboradores, a empresa e seus 
órgãos executivos contra as consequências negativas de quaisquer violações.
Somente uma postura honesta, leal e que respeite as leis possibilita o crescimento sustentável 
da PAGAR e a lealdade de longo prazo de nossos clientes, colaboradores, fornecedores e 
prestadores de serviços, permite a crescimento sustentável, garante o emprego de nossos 
colaboradores em um ambiente corporativo saudável, dinâmico e ético.
Agradecemos por seu apoio e por cumprir com este Código de Conduta e todas as demais 
políticas de Compliance que compõem nossa Governança Corporativa.
CÓDIGO DE CONDUTA DA PAGAR

3. PRINCÍPIOS E ESCOPO DO CÓDIGO DE CONDUTA
O Código de Conduta da PAGAR se aplica à administração, à equipe executiva e a todos os 
colaboradores da PAGAR. O Código de Conduta aplica-se sem exceção a todas as unidades 
de negócios, em todos os campos de atividade da empresa.

3.1. PRINCÍPIOS
Este Código de Conduta (“Código”) orienta as ações da PAGAR e as suas partes interessadas, 
através de declarações de princípios e valores, fundamentos morais e éticos universais, a fim 
de estabelecer relações baseadas na confiança, transparência e benefício mútuo.
Apoiamos plenamente os princípios do Pacto Global das Nações Unidas, baseando os nossos 
valores fundamentais no respeito pelos direitos humanos, pelos direitos laborais, pelo 
ambiente e pela luta contra a corrupção. 
O presente Código inclui os princípios éticos e normas de conduta nacionais e internacionais 
que devem ser mantidos por sócios, gestores e colaboradores da PAGAR em suas relações 
interna e externa com os clientes e outros parceiros com os quais a PAGAR se relaciona. 

3.2. ESCOPO
Este Código aplica-se a todas as operações da PAGAR LTDA., suas filiais e 
subsidiárias. Da mesma forma, inclui todos os diretores e colaboradores da PAGAR que devem 
ter o devido conhecimento do seu conteúdo e cumpram seus requisitos.
Os diretores e colaboradores devem conhecer o Código, cumprir com seus princípios, 
capacitar a sua equipe para este fim, monitorar desvios em sua aplicação, agir na correção 
de quaisquer desvios e solicitar a sua atualização quando necessário.
A PAGAR deseja e espera que os grupos de interesse com os quais a PAGAR se relaciona 
compartilhem os princípios consagrados neste Código e atuem em conformidade com eles 
em seu relacionamento com a PAGAR.

4. COMPLIANCE JURÍDICO
Para a PAGAR o cumprimento de todas as leis e regulamentos aplicáveis, seja local, nacional 
e internacionalmente é sempre evidente e obrigatório, é o Compliance jurídico. 
Esta é a única maneira de alcançar um crescimento sustentável e garantir a lealdade de 
clientes, colaboradores, prestadores de serviços e fornecedores a longo prazo. 
O Compliance jurídico visa preservar a reputação da PAGAR e evitar reclamações por danos 
e sanções contra colaboradores, a administração da empresa e a própria empresa. As 
CÓDIGO DE CONDUTA DA PAGAR
violações às leis, regulamentos e aos códigos internos de conduta são consideradas como 
violações ao contrato de trabalho e serão penalizadas de acordo com a gravidade de cada 
violação.
O cumprimento da lei é parte integrante da cultura corporativa da PAGAR e todos os 
colaboradores executivos, gestores, vivem e mantêm esta cultura; eles devem estar 
familiarizados com as leis, regulamentos e regras internas da empresa, cumprir e ajudar os 
demais colaboradores a cumpri-las também, adotando a cultura top down. 
Cumpre aos colaboradores executivos apoiar o treinamento regular dos demais 
colaboradores, e assegurar que as fiscalizações, auditorias e inspeções sejam realizadas 
conforme necessidade e estar sempre dispostos a ouvir.

4.1. DIREITOS HUMANOS
Os diretores e colaboradores da PAGAR deverão tratar todas as pessoas com respeito e 
dignidade, fomentando a diversidade, promovendo a igualdade de oportunidades para todos 
e uma cultura ética de acordo com as convenções e recomendações da Organização 
Internacional do Trabalho (OIT).
A PAGAR deseja e espera a mesma conduta por parte dos grupos de interesse com os quais 
a PAGAR se relaciona.

4.2. TRABALHO INFANTIL
Os diretores e colaboradores devem garantir que a PAGAR não utilize o trabalho infantil em 
suas operações.
A idade mínima para trabalhar é determinada pela legislação nacional. Proibido o trabalho do 
melhor de 16 anos, exceto quando contratado na condição de aprendiz a partir dos 14 anos. 
Os jovens com menos de 18 anos não deveriam ser empregados para desempenhar qualquer 
trabalho que, pela sua natureza ou pelas circunstâncias em que é realizado, possa prejudicar 
sua saúde física, mental ou moral, desempenho escolar, segurança ou seu espírito, ou que 
deva ser realizado em local subterrâneo ou debaixo de água.

4.3. TRÁFICO DE PESSOAS E TRABALHO FORÇADO
Os diretores e colaboradores devem abster-se de violar os direitos humanos. Não devem 
incorrer ou beneficiar da utilização do trabalho forçado ou obrigatório.
Todo emprego é voluntário (sob contrato de trabalho) e os colaboradores são livres de finalizar 
sua contratação ou de abandonar seu posto de trabalho conforme o disposto em lei.
CÓDIGO DE CONDUTA DA PAGAR

4.4. CONDIÇÕES DE TRABALHO
A PAGAR proporcionará aos seus colaboradores um ambiente de trabalho livre de violência e 
tratamento desumano, sem qualquer assédio sexual, abuso sexual, punição física ou tortura, 
coação física ou psicológica ou abuso verbal, ou ameaça de tal tratamento, especialmente no 
que diz respeito a relações hierárquicas de subordinação. O ambiente de trabalho deve ser 
seguro e saudável.

4.5. NÃO DISCRIMINAÇÃO
As políticas de emprego da PAGAR são isentas de preconceitos relacionados com questões 
de raça, etnia, cor, origem nacional, idade, condição médica, deficiência, sexo, gravidez, 
estado civil, condição social, orientação sexual, religião, preferências políticas, crenças 
filosóficas, ideais sindicais ou outros motivos previstos na legislação vigente. As condições de 
trabalho e as políticas de recrutamento devem basear-se em avaliações objetivas e justas do 
trabalho. 
Na PAGAR os colaboradores devem ser tratados com respeito e dignidade, e proporcionando 
as mesmas oportunidades de acesso ao trabalho e à promoção profissional, garantindo 
sempre a ausência de fatores discriminatórios como os mencionados no parágrafo anterior.
Na PAGAR devem ser estabelecidos e aplicados critérios de desempenho meritocráticos em 
suas decisões com respeito à contratação, promoção e remuneração de seus colaboradores.

4.6. PRÁTICAS TRABALHISTAS
Deve ser cumprida a legislação trabalhista aplicável aos locais onde a PAGAR exerce as suas 
atividades, em conformidade com os acordos coletivos e convenções em vigor.

5. INTEGRIDADE NOS NEGÓCIOS
A PAGAR é uma empresa que agrega valor aos seus produtos e serviços através de soluções 
sustentáveis, criativas, inovadoras e responsáveis. 
Os parceiros comerciais confiam na postura lícita e integra da PAGAR em todos os momentos 
e fases de uma negociação. Da mesma forma que a PAGAR garante e espera que seus 
parceiros de negócios cumpram todas as leis e regulamentos aplicáveis em todas as 
atividades e decisões.
A PAGAR é responsável por suas ações e cumpre seus compromissos com clientes, parceiros 
de negócios e colaboradores, bem como com autoridades governamentais e de supervisão. 
CÓDIGO DE CONDUTA DA PAGAR
Quando a PAGAR lida com governos, autoridades e tribunais, sempre coopera conforme 
prescrito por lei e com transparência em todas suas ações.
A PAGAR espera que todos seus colaboradores cumpram integralmente toda a legislação 
aplicável a cada atividade corporativa, sendo que em caso de dúvidas o colaborador deve 
contatar o Local Compliance Officer.

6. COMBATE À CORRUPÇÃO
Corrupção é o ato de se utilizar indevidamente de uma posição de influência para obter 
vantagens ou mesmo realizar alguma ação que é considerada ilegal de acordo com as leis 
vigentes.
A corrupção é proibida em todo o mundo (Convenção das Nações Unidas contra a Corrupção). 
A PAGAR dá grande importância ao fato de ser uma empresa livre de corrupção. A PAGAR não 
tolera, sob nenhuma circunstância, qualquer forma de corrupção ativa ou passiva, nem em 
relação a parceiros de negócios ou colaboradores.
A corrupção pode gerar consequência para a PAGAR tais como: pagamento de multa, 
proibição de participação em licitações; perda de contratos em andamento, lucro, exposição, 
danos à imagem, enfraquecimento da marca pela exposição negativa; já o funcionário que 
praticar atos de corrupção poderá responder a processo criminal, além de demissão por justa 
causa.
A PAGAR nunca concede gratificações aos funcionários públicos - em qualquer parte do 
mundo. Nos negócios, a PAGAR proíbe gratificações, como convites ou presentes, a parceiros 
e clientes.
A fim de evitar violações das disposições anticorrupção e as consequências resultantes, a 
administração, os gerentes e os colaboradores devem abster-se de realizar quaisquer atos de 
corrupção ou atos que possam parecer com corrupção. Isso se aplica em relação a 
funcionários públicos e, em geral, a parceiros de negócios.
Em caso de dúvidas o colaborador deve contatar o Local Compliance Officer.

7. RESPEITO À CONCORRÊNCIA JUSTA E HONESTA E À 
LEGISLAÇÃO ANTITRUSTE
A PAGAR afirma seu lugar no mercado com foco no cliente, qualidade e inovação; aceita e 
respeita a concorrência justa e honesta, com adesão às regras e regulamentos internacionais 
da lei antitruste e de concorrência.
CÓDIGO DE CONDUTA DA PAGAR
A PAGAR evita a fixação de preços, a divisão de clientes ou territórios de vendas entre 
concorrentes, boicotes anticoncorrenciais e outros métodos injustos de concorrência que 
visam obter vantagens comerciais.
Todos os colaboradores devem abster-se de condutas que levem a restrição da concorrência, 
de acordo com a Lei Anticorrupção tais como: acordos para fixação de preço, criação de cartel, 
venda casada, restrições territoriais e de base de clientes etc.
A PAGAR não tolera qualquer tentativa de obter informações da concorrência, por meio de 
espionagem industrial, roubo ou suborno.
Infrações à concorrência podem levar a sérios riscos e responsabilidades para o colaborador 
que praticar estas violações, para a administração, e para empresa; além do potencial risco 
de prejudicar a reputação da empresa.
Para garantir o cumprimento integral de todos os requisitos legais, todas as ações devem ser 
coordenadas pelo Local Compliance Officer, se tiver alguma dúvida, o colaborador deve entrar 
em contato.

8. COMBATE À LAVAGEM DE DINHEIRO E FINANCIAMENTO DO 
TERRORISMO
A PAGAR cumpre todas suas obrigações estatutárias para evitar lavagem de dinheiro; repudia 
e não participa de transações que possam trazer dinheiro ilegal para circulação.
A PAGAR mantém relações de negócios apenas com parceiros de negócios respeitáveis que 
cumpram a lei e obtenham seus recursos financeiros legitimamente. 
A PAGAR orienta e cobra de seus colaboradores a análise cuidadosa das atividades e 
circunstâncias de negócios de todos os parceiros de negócios; para evitar transações que 
possam envolver lavagem de dinheiro, dando especial atenção a formas incomuns de 
pagamento, especialmente transações em dinheiro ou contratos suspeitos, que possam 
causar uma impressão duvidosa.
Todos os casos questionáveis, suspeitos, devem ser submetidos à análise pelo Local 
Compliance Officer.

9. SIGILO E SEGREDO COMERCIAL 
A PAGAR protege os negócios e os segredos comerciais, tais como: a propriedade intelectual, 
informações pessoais, acordos contratuais, relatórios, planos de negócios e produtos, 
serviços, fórmulas. Sistema, softwares, algoritmos e outras informações confidenciais.
CÓDIGO DE CONDUTA DA PAGAR
A PAGAR adota todas as medidas necessárias para proteger seus próprios negócios e 
segredos comerciais; bem como de parceiros de negócios, contra o acesso não autorizado 
por colaboradores, terceiros ou pelo público. A PAGAR leva a sério suas obrigações de 
confidencialidade, sigilo e segredo comercial; sendo certo que todas as declarações à 
imprensa, rádio e televisão são feitas apenas pela assessoria de imprensa da PAGAR.
A PAGAR preza pela confiabilidade, honestidade e integridade em suas comunicações, 
internas e externas, bem como em relatórios sobre as operações de negócios da empresa 
com relação a seus colaboradores, clientes, parceiros de negócios, autoridades e o público 
em geral.
Todos os colaboradores devem contribuir para garanta de que os relatórios internos e 
externos, registros e outros documentos estejam completos e corretos, enviados 
pontualmente e sejam apropriados ao sistema - em conformidade com as regras e requisitos 
estatutários e legislação em vigor, bem como devem abster-se de divulgar, copiar, enviar para 
terceiros, ou utilizar para outro fim que não o desenvolvimento de seu trabalho, qualquer 
informação relacionada ao negócio e segredos de negócio, sem prévia autorização da 
Diretoria da PAGAR.

10. DOAÇÕES E PATROCÍNIOS
A PAGAR estabelece que para quaisquer tipos de Doações e Patrocínios, em nome da 
empresa, primeiro o colaborador deve buscar a aprovação do Local Compliance Officer.
A PAGAR estabelece que nenhuma Doação ou Patrocínio deve ser oferecido ou prometido 
com o propósito de influenciar, direta ou diretamente: (i) decisões de negócios; (ii) ação, 
omissão ou decisão de órgão ou Agente Público; ou (iii) decisão comercial incompatível com 
a legislação em vigor, com os interesses ou com as políticas internas da
A PAGAR poderá realizar Doações a entidades e instituições idôneas e íntegras, motivadas 
por razões filantrópicas legítimas e em apoio a causas humanitárias, culturais, esportivas e 
educacionais, bem como a ações relacionadas ao bem-estar da comunidade onde a PAGAR 
possua operação/atividade, sendo certo que a doação deverá ocorrer em conformidade com 
a Legislação em vigor, com os princípios regidos e em consonância com este Código de 
Conduta e que sempre tenha aprovação do Local Compliance Officer.

11. PRESENTES, BRINDES E HOSPITALIDADES
A PAGAR estabelece que para quaisquer tipos de Presente, Brindes e Hospitalidades, que 
venha oferecer em nome da empresa, primeiro o colaborador deve buscar a aprovação do 
Local Compliance Officer.
CÓDIGO DE CONDUTA DA PAGAR
A PAGAR estabelece que, em hipótese alguma, poderá ser concedido e/ou recebido quaisquer 
presentes ou hospitalidades em dinheiro ou equivalentes em dinheiro, tais como valespresente, ações, empréstimos, pagamentos de diárias ou na forma de itens luxuosos ou férias.
A PAGAR orienta que o colaborador, caso venha a receber algum brinde, presente, 
hospitalidade, acima do valor de R$100,00 (cem) reais, deve agradecer e ressaltar que pelo 
motivo do Código de Conduta da empresa, não poderá aceitar. Para algum brinde, presente, 
hospitalidade abaixo deste valor, o colaborador poderá aceitar, contudo deverá informar o 
Local Compliance Officer .

12. MEDIDAS DE SEGURANÇA CIBERNÉTICA DA TECNOLOGIA 
DA INFORMAÇÃO
A PAGAR adota todas as precauções necessárias para proteger seus sistemas de Tecnologia 
da Informação contra ameaças, internas e externas, e uso indevido.
O uso de Tecnologia da Informação carrega riscos inerentes à segurança de dados, motivo 
pelo qual é crucial que todos os colaboradores sigam as regras necessárias para o uso seguro 
dos sistemas de Tecnologia da Informação, a fim de se evitar incidentes tais como: 
vazamentos, invasões aos sistemas, sequestro de dados etc. 
Na PAGAR, a proteção dos sistemas, programas e utilitários, são acessados por credenciais 
de identificação e autenticação individuais. A senha é pessoal, sigilosa e intransferível; a 
instalação regular das atualizações de Tecnologia da Informação nas estações de trabalho e 
uso restrito de software e hardware autorizados, exclusivamente instalados pela Tecnologia 
da Informação. 
Os diretores e colaboradores da PAGAR, devem tratar com confidencialidade à comunicação 
diária por e-mail, e todas as informações em formato eletrônico, como planos, citações e assim 
por diante.
Dúvidas, problemas ou anormalidades nestas questões específicas de tecnologia da 
informação devem ser esclarecidas diretamente com a Tecnologia da Informação da PAGAR.

13. LEALDADE À PAGAR 
A PAGAR espera que seus colaboradores sejam leais e o protejam de quaisquer conflitos de 
interesses. Quando as decisões profissionais não são tomadas imparcialmente e no melhor 
interesse da PAGAR, surge o conflito de interesses, por exemplo, se colaboradores ou 
membros de suas famílias do colaborador detêm participações em empresas ou ocupam 
cargos executivos em empresas que são clientes, fornecedores, concorrentes ou, de outra 
CÓDIGO DE CONDUTA DA PAGAR
forma, têm conexões comerciais com a PAGAR. Um conflito de interesses pode levar a 
decisões equivocadas e perdas financeiras para a PAGAR. 
No caso de um conflito de interesses ou se você não tiver certeza sobre a existência de um 
conflito de interesses, você deve notificar o Local Compliance Officer imediatamente, para 
encontrar uma solução mutuamente aceitável o mais rápido possível.

14. EQUIPAMENTOS E UTILITÁRIOS
A PAGAR espera e orienta todos seus colaboradores para lidar com responsabilidade com 
equipamentos de trabalho e propriedade intelectual da PAGAR.
A PAGAR disponibilizará aos seus colaboradores bens e outros ativos apenas como 
destinados a tarefas corporativas, sendo certo que o uso privativo de qualquer bem ou utilitário 
depende de aprovação prévia ou regulamentos internos da empresa. 
Todos os colaboradores devem fazer uso dos bens e utilitários com zelo, prudência e respeito; 
de igual forma, os colaboradores que eventualmente tiverem acesso ao uso e posse de 
propriedades de terceiros, como aluguel de carros.
O colaborador que fizer o uso para fins pessoais, ilegais ou indevidos de bens ou utilitários da 
PAGAR, ou de terceiros utilizados, estará sujeito às penalidades previstas em lei, inclusive 
criminais, de acordo com a gravidade do desvio de uso, além de medidas disciplinares 
trabalhistas, o que pode até resultar em demissão por justa causa.

15. NEGOCIAÇÃO ÉTICA E RESPONSABILIDADE SOCIAL
Respeitar os direitos humanos e proteger as minorias é de suma importância para a PAGAR. 
Todos os colaboradores, clientes e parceiros de negócios têm o direito de serem respeitados 
e tratados com cordialidade. 
A PAGAR repudia a prática de assédio, bullying e intimidação em qualquer forma. 
A PAGAR repudia e não tolera o trabalho forçado ou infantil, ou qualquer forma de exploração 
e discriminação, seja devido à nacionalidade ou origem étnica, sexo ou estado civil, idade, 
deficiência, religião ou crença, orientação sexual ou por qualquer outro motivo.
A PAGAR aplica os melhores esforços para criar e manter um ambiente de trabalho saudável 
e seguro para seus colaboradores, onde as leis e regulamentações que regem a saúde e a 
segurança no trabalho são respeitadas.
CÓDIGO DE CONDUTA DA PAGAR
A PAGAR não realiza negócios com parceiros comerciais e de cooperação em todo o mundo 
que não observem as diretrizes acima, de repúdio ao trabalho infantil, trabalho forçado, 
assédio, bullying e intimidação.
Qualquer comentário negativo ou insultuoso sobre os colaboradores e a empresa prejudica a 
pessoa vitimada, a reputação da PAGAR e o ambiente de trabalho. Em razão disto, a PAGAR 
orienta e adverte seus colaboradores sobre os riscos das práticas inadequadas, adotando 
medidas preventivas e corretivas ao comportamento insultuoso, calunioso e difamatório para 
proteção de seus colaboradores e da própria empresa.
A PAGAR promove a cooperação, comunicação e feedback, enxergando os conflitos como 
oportunidades. A PAGAR confia em seus colaboradores; delegando tarefas e 
responsabilidades compatíveis com os cargos e funções atribuídas. 
A PAGAR garante, com transparência e processos documentados, que quaisquer violações e 
problemas podem ser identificados em um estágio inicial e as contramedidas necessárias 
podem ser implantadas.
A PAGAR encoraja seus colaboradores a relatarem quaisquer circunstâncias críticas e dúvidas 
ao seu superior ou ao gerente, sem medo de consequências negativas.
A PAGAR apoia seus colaboradores e investiga todas as dúvidas expressas de forma justa. 
A PAGAR não tolera quaisquer intimidações ou sanções contra colaboradores que, de boa-fé, 
denunciarem desvios comportamentais, financeiros, de procedimentos ou suspeitos.

16. SEGURANÇA E QUALIDADE DOS PRODUTOS E SERVIÇOS 
DA PAGAR 
A PAGAR faz uso de tecnologia avançada, obedecendo padrões de qualidade e segurança do 
Brasil e mundial; com a garantia de alta qualidade, inovação e os padrões de segurança de 
nossos produtos e serviços. A PAGAR visa garantir que nenhum dos nossos produtos ameace 
a saúde e a segurança das pessoas e animais que entram em contato com eles.
A PAGAR preza pelo cumprimento de todas as regras, padrões legais, tecnológicos, de 
vigilância sanitária e medicina veterinária sobre segurança de produtos. 

17. TOMAR DECISÃO
Sempre que você tomar uma decisão ou seguir instruções, faça a si mesmo as seguintes 
perguntas:
CÓDIGO DE CONDUTA DA PAGAR
● Minha decisão é lícita e está de acordo com as diretrizes empresariais da PAGAR e com 
os requisitos deste Código de Conduta?
● Minha decisão é baseada em uma avaliação profissional responsável?
● Eu manteria a minha decisão se ela se tornasse pública?
● Minha decisão confirma a reputação da PAGAR?
Se você tiver alguma dúvida sobre qualquer uma dessas perguntas, peça aconselhamento 
para o Local Compliance Officer, que é seu contato para todas as questões relativas a este 
Código de Conduta.
A PAGAR sempre ouvirá as perguntas ou dúvidas sobre possíveis desvios de conduta e está 
aberta às sugestões sobre como melhorar os procedimentos de compliance.
A PAGAR garante, sempre que solicitado, o sigilo absoluto de qualquer denúncia. 

18. CANAL DE DENÚNCIA
A PAGAR define o e-mail lenon.rodrigues@pagar.com.br como Canal de Contato para as 
denúncias e ressalta que o assunto será tratado com confidencialidade.

19. LOCAL COMPLIANCE OFFICER DA PAGAR
A PAGAR define o Diretor abaixo identificado, como responsável pelo Local Compliance 
Officer.
O Sr. Lenon Rodrigues Botelho Fernandes
Telefone: (31) 98897-1310 
E-mail: lenon.rodrigues@pagar.com.br
Suas preocupações, considerações e perguntas em relação ao Código de Conduta serão 
levadas a sério e serão tratadas com estrita confidencialidade e eficiência.
Contamos com você!
PAGAR LTDA.
CÓDIGO DE CONDUTA DA PAGAR`,
      },
    };

    // Simula um pequeno atraso de carregamento
    setTimeout(() => {
      setPolicy(
        policies[policyId] || {
          title: 'Política',
          content: 'Conteúdo não encontrado',
        }
      );
      setLoading(false);
    }, 300);
  }, [policyId]);

  if (loading) {
    return (
      <div className='p-8 flex justify-center items-center h-full'>
        Carregando...
      </div>
    );
  }

  return (
    <div className='p-8'>
      <h2 className='text-2xl font-bold mb-6 text-white-100'>
        {policy?.title}
      </h2>
      <div className='prose max-w-none'>
        {policy?.content.split('\n\n').map((paragraph, index) => (
          <p key={index} className='mb-4 text-white-100'>
            {paragraph}
          </p>
        ))}
      </div>
    </div>
  );
};

// Componente para mostrar produtos
// Substitua apenas o componente ProductsContent no seu arquivo ModalComponents.tsx

//ATENÇÃO! MODAL DE PRODUTOS NÃO FOI APROVADO. MANTIVE APENAS PARA REFERÊNCIA FUTURA POIS TEM BOAS POSSIBILIDADES DE APLICAÇÃO EM OUTRO LOCAL

export const ProductsContent: React.FC<ProductsContentProps> = ({
  segment,
}) => {
  const [products, setProducts] = useState<ProductsData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    // Mantendo seu código de carregamento de dados existente...
    const productsData: Record<string, ProductsData> = {
      personal: {
        title: 'Produtos Para Você',
        items: [
          { id: 1, image: ParaVoce1, title: 'Pagar Educação' },
          { id: 2, image: ParaVoce2, title: 'Pagar Arrecadação' },
          { id: 3, image: ParaVoce3, title: 'Pagar Compras Online' },
          { id: 4, image: ParaVoce4, title: 'Pagar Condomínio' },
          { id: 5, image: ParaVoce5, title: 'Pagar Tributos' },
          { id: 6, image: ParaVoce6, title: 'Pagar Assistente Financeiro' },
        ],
      },
      business: {
        title: 'Produtos Para Sua Empresa',
        items: [
          { id: 5, image: ParaEmpresa1, title: 'Gerenciador Caixa Empresas' },
          { id: 6, image: ParaEmpresa2, title: 'Gerenciador Caixa Empresas' },
        ],
      },
      government: {
        title: 'Produtos Para o Governo',
        items: [
          { id: 7, image: ParaGoverno1, title: 'Gerenciador Caixa' },
          { id: 8, image: ParaGoverno2, title: 'Gerenciador Caixa' },
        ],
      },
    };

    setTimeout(() => {
      setProducts(productsData[segment] || { title: 'Produtos', items: [] });
      setLoading(false);
    }, 300);
  }, [segment]);

  if (loading) {
    return (
      <div className='p-8 flex justify-center items-center h-full text-white-100'>
        Carregando...
      </div>
    );
  }

  return (
    <div className='p-8'>
      <h2 className='text-2xl font-bold mb-8 text-white-100 text-center'>
        {products?.title}
      </h2>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10'>
        {products?.items.map(product => (
          <div
            key={product.id}
            className='flex flex-col items-center rounded-2xl transition-transform duration-300 hover:scale-105 p-4'
          >
            {/* Container da imagem mais alto */}
            <div className='h-64 w-full flex items-center justify-center mb-4'>
              <img
                src={product.image}
                alt={product.title}
                className='h-auto w-auto max-h-full max-w-full rounded-xl'
              />
            </div>

            {/* Título abaixo da imagem */}
            <h3 className='text-white-100 text-xl font-bold text-center'>
              {product.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

// Componente de contêiner do modal que decide qual conteúdo mostrar
export const ModalContainer: React.FC = () => {
  const { modal, closeModal } = useModal();

  // Renderiza o conteúdo adequado com base no tipo
  const renderModalContent = (): React.ReactNode => {
    const { type, data } = modal;

    if (type === 'policy' && data) {
      return <PolicyContent policyId={data} />;
    } else if (type === 'products' && data) {
      return <ProductsContent segment={data} />;
    }

    return null;
  };

  return (
    <Modal isOpen={modal.isOpen} onClose={closeModal}>
      {renderModalContent()}
    </Modal>
  );
};
